<div class="app-export-item" [class]="activeMenuItemKey$ | async" *ngxPermissionsOnly="permissions" [attr.id]="title">
  <i [class]="icon" class="app-export-item__icon"></i>
  <div class="app-export-item__title">{{title | translate}}</div>
  <div *ngIf="subtitle" class="app-export-item__subtitle">{{subtitle | translate}}</div>
  <button class="app-export-item__button" (click)="onClick()">
    <i [class]="downloadIcon"></i>
    <span>{{exportButtonText | translate}}</span>
  </button>
</div>
